import { render, staticRenderFns } from "./CountedServiceTypeInfo.vue?vue&type=template&id=69c63e33&"
import script from "./CountedServiceTypeInfo.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports